import Vue from 'vue';
import Vuex from 'vuex';
import Fuse from 'fuse.js';
import axios from 'axios';
// import data from './data/new-data.json';

// const _ = require('lodash');

const baseUrl = 'https://sheets.googleapis.com/v4/spreadsheets/';
const apiKey = 'AIzaSyAWOdwaX9RAeTLO9tqlGovFg-CWhGX4TDM';
const sheetId = '1b1Jn5K24VQymVo6KnKb9UrXv4YMStg-j3EEZRAXfzuA';
const url = `${baseUrl}${sheetId}/values/WebData!A1:O2000?key=${apiKey}`;

const zipObject = (props, values) => props.reduce((prev, prop, i) => Object.assign(prev, { [prop]: values[i] ? values[i] : '' }), {});


Vue.use(Vuex);

const states = () => ({
  cars: [],
  initialCars: [],
  loading: false,
});

const mutations = {
  LOADING(state) {
    state.loading = true;
  },
  SET_PRODUCTS(state, payload) {
    state.cars = payload;
    state.initialCars = payload;
  },
  updateCars(state, payload) {
    state.cars = payload.newCars;
  },
  FINISH(state) {
    state.loading = false;
  },
};

const actions = {
  async getData({ commit }) {
    commit('LOADING');
    const response = await axios.get(url);
    const rows = response.data.values;
    const properties = rows.shift();
    const data = [];
    // eslint-disable-next-line
    for (const i in rows) {
      data.push(zipObject(properties, rows[i]));
    }
    commit('SET_PRODUCTS', data);
    commit('FINISH');
  },
  search({ commit, dispatch, state }, keyword) {
    commit('LOADING');
    if (keyword.length === 0 || keyword === null) {
      dispatch('getData');
    } else if (keyword.includes(':')) {
      let query = keyword.trim().split(' ');
      const filters = [];
      query = query.filter((item) => {
        if (item.includes(':')) {
          const tmp = item.split(':');
          filters.push({ key: tmp[0], value: tmp[1] });
        }
        return !item.includes(':');
      });
      query = query.join(' ');
      console.log(filters);
      const { initialCars } = state;
      const filterCars = initialCars.filter((car) => {
        let passFilter = true;
        filters.forEach((filter) => {
          if (car[filter.key].toLowerCase().localeCompare(filter.value) !== 0) {
            passFilter = false;
          } // 0 = exact same
        });
        return passFilter;
      });
      if (query.length) {
        console.log(query);
        dispatch('filter', { data: filterCars, query });
      } else {
        commit('updateCars', { newCars: filterCars });
        commit('FINISH');
      }
    } else {
      dispatch('filter', { data: state.initialCars, query: keyword });
    }
  },
  async filter({ commit }, payload) {
    const options = {
      shouldSort: true,
      caseSensitive: false,
      threshold: 0.1,
      tokenize: true,
      distance: 300,
      location: 0,
      maxPatternLength: 128,
      minMatchCharLength: 1,
      keys: [
        'year',
        'status',
        'name',
        'turo-id',
        'ga-id',
        'ryde-id',
        'license-plate',
        'make',
        'model',
        'vin',
        'loc',
        'regis-exp',
        'vin',
        'vehicle-type',
      ],
    };

    const search = new Fuse(payload.data, options);
    const result = await search.search(payload.query);
    const filteredItems = {
      newCars: result,
    };

    commit('updateCars', filteredItems);
    commit('FINISH');
  },
};

export default new Vuex.Store({
  state: states,
  mutations,
  actions,
});
